/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface EvidenceWarnings
 */
export interface EvidenceWarnings {
    /**
     * 
     * @type {string}
     * @memberof EvidenceWarnings
     */
    'detectedDpi'?: EvidenceWarningsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceWarnings
     */
    'calculatedDpi'?: EvidenceWarningsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceWarnings
     */
    'colorGradation'?: EvidenceWarningsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceWarnings
     */
    'heightMillis'?: EvidenceWarningsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceWarnings
     */
    'widthMillis'?: EvidenceWarningsWidthMillisEnum;
}

export const EvidenceWarningsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type EvidenceWarningsDetectedDpiEnum = typeof EvidenceWarningsDetectedDpiEnum[keyof typeof EvidenceWarningsDetectedDpiEnum];
export const EvidenceWarningsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type EvidenceWarningsCalculatedDpiEnum = typeof EvidenceWarningsCalculatedDpiEnum[keyof typeof EvidenceWarningsCalculatedDpiEnum];
export const EvidenceWarningsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type EvidenceWarningsColorGradationEnum = typeof EvidenceWarningsColorGradationEnum[keyof typeof EvidenceWarningsColorGradationEnum];
export const EvidenceWarningsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type EvidenceWarningsHeightMillisEnum = typeof EvidenceWarningsHeightMillisEnum[keyof typeof EvidenceWarningsHeightMillisEnum];
export const EvidenceWarningsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type EvidenceWarningsWidthMillisEnum = typeof EvidenceWarningsWidthMillisEnum[keyof typeof EvidenceWarningsWidthMillisEnum];


